export default __webpack_public_path__ + "static/media/testimonialConfirm.ad991819.svg";